import React from 'react';

import { useAppSelector } from 'store/hook';

import SidebarSelectorDropdownFilterButton from './SidebarSelectorDropdownFilterButton';
import { SELECTOR_ITEM_TYPES } from '../constants';

const SidebarSelectorDropdownControlsUser = () => {
  const { communities, competitors } = useAppSelector((state) => state.global);

  const communitiesCount = (communities ?? []).length;
  const competitorsCount = (competitors ?? []).length;

  return (
    <>
      <SidebarSelectorDropdownFilterButton type={SELECTOR_ITEM_TYPES.ALL} />
      <SidebarSelectorDropdownFilterButton type={SELECTOR_ITEM_TYPES.COMMUNITY} count={communitiesCount} />
      <SidebarSelectorDropdownFilterButton type={SELECTOR_ITEM_TYPES.COMPETITOR} count={competitorsCount} />
    </>
  );
};
export default SidebarSelectorDropdownControlsUser;
